import { createSelector } from "@reduxjs/toolkit";

export const authState = createSelector(state => state.auth, auth => auth.isAuthenticated)
export const profileState = createSelector(state => state.auth.user, user => user)
export const isReady = createSelector(state => state.auth, auth => auth.isReady)